<template>
    <!-- modal confirm area -->
    <b-modal v-model="isModalShow" id="alertConfirm"
            :size="size"
            :title="title"
            :hide-header="isHideHeader"
            :hide-footer="isHideFooter"
            :body-bg-variant="bodyBackground"
            :body-text-variant="bodyText"
            :header-bg-variant="headerBgVariant"
            :no-close-on-backdrop="isCloseBackdrop"
            :centered="isCentered"
            @hide ="handleCancel"
            >
        <b-container fluid> 
            <span v-html="msgConfirm"/>
        </b-container>
        <div slot="modal-footer" class="text-center margin-auto">
            <button v-if="isButtonOK" size="sm" :class="okButtonClass" @click="okActionAlert(); evtClickOk();">
                {{$t(okButtonLbl)}}
            </button>
            <button v-if="isButtonCancel" size="sm" :class="cancelButtonClass" @click="evtClickCancel()">
                <!-- キャンセル -->
                {{$t(cancelButtonLbl)}}
            </button>
        </div>
    </b-modal>
    <!-- end modal confirm area -->
</template>
<script>
import EventBus from "assets/js/eventBus";
export default {
    name: "AlertConfirm",
    props:{
        headerBgVariant:{
            type: String,
            default: 'warning'
        },
        okButtonClass: {
            type: String,
            default: 'btn btn-sm btn-danger mr-2'
        },
        cancelButtonClass: {
            type: String,
            default: 'btn btn-sm btn-secondary'
        },
        msgConfirm:{
            type: String,
            default: ''
        },
        okAction:{
            default: null,
        },
        cancelAction:{
            default: null,
        },
        bodyBackground: {
            type: String,
            default: ''
        },
        bodyText:{
            type: String,
            default:'danger'
        },
        size: {
            type: String,
            default: 'md'
        },
        title: {
            type: String,
            default: ''
        },
        isHideHeader: {
            type: Boolean,
            default: false
        },
        isHideFooter:{
            type: Boolean,
            default: false
        },
        isCloseBackdrop:{
            type: Boolean,
            default: true
        },
        isCentered:{
            type: Boolean,
            default: false
        },
        cancelButtonLbl:{
            type:String,
            default: 'common.buttons.cancel'
        },
        okButtonLbl:{
            type: String,
            default: 'common.buttons.OK'
        },
        isButtonCancel:{
            type: Boolean,
            default: true
        },
        isButtonOK:{
            type: Boolean,
            default: true
        },
        isCustomFooter:{
            type: Boolean,
            default: false
        },
        isChildModal: {
            type: Boolean,
            default: false
        }
    },
    data: function(){
        return {
            isModalShow: true,
            okActionAlert: null,
            cancelActionAlert: null
        }
    },
    mounted: function(){
        var _this = this;

        if(_this.okAction == null || _this.okAction == undefined){
            _this.okActionAlert = function (){_this.isModalShow = false};
        } else {
            _this.okActionAlert = _this.okAction;
        }

        if (_this.cancelAction != undefined && _this.cancelAction != null) {
            _this.cancelActionAlert = _this.cancelAction;
        }
    },
    methods: {
        evtClickOk: function(){
            EventBus.$emit('evtClickOk', true);
        },
        evtClickCancel:function(){
            if(this.cancelActionAlert != undefined && this.cancelActionAlert != null) {
                this.cancelActionAlert();
            }

            this.isModalShow = false;
        },
        /**
         *  Exec close modal
         * @param {Any} evt, event close
         */
        handleCancel(evt){
            if (this.cancelActionAlert != undefined && this.cancelActionAlert != null) {
                this.cancelActionAlert();
            }

            evt.preventDefault();
            this.isModalShow = false;
        }
    },
    /*
    * Function watch
    */
    watch: {
        /*
        *  event close modal
        */
        isModalShow(newVal, oldVal) {
            if (oldVal) {
               if(!this.isChildModal){
                    EventBus.$emit('closed', 'AlertConfirm');
                    this.$emit('closedModal');
                }
                else{
                    this.$emit('child-modal-close', 'AlertConfirm');
                }
            }
        }
    }
}
</script>


